module.exports = __webpack_public_path__ + "img/流体力学1_7_2.7e732a67.jpg";